// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type GlobalSearchModalQueryVariables = Types.Exact<{
  search: Types.Scalars['String']['input'];
}>;


export type GlobalSearchModalQuery = { __typename?: 'Query', globalSearch: Array<{ __typename?: 'GlobalSearchResult', record: { __typename?: 'GlobalSearchRecord', id: string, parent:
        | { __typename?: 'Bill', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string }, project:
            | { __typename?: 'StandaloneProject', id: string, name: string }
            | { __typename?: 'Region', id: string, name: string }
            | { __typename?: 'Market', id: string, name: string }
            | { __typename?: 'Community', id: string, name: string }
            | { __typename?: 'Subdivision', id: string, name: string }
            | { __typename?: 'Lot', id: string, name: string }
            | { __typename?: 'Structure', id: string, name: string }
            | { __typename?: 'Unit', id: string, name: string }
           }
        | { __typename?: 'Commitment', id: string, accountingNumber: number, name: string, project:
            | { __typename?: 'StandaloneProject', id: string, name: string }
            | { __typename?: 'Region', id: string, name: string }
            | { __typename?: 'Market', id: string, name: string }
            | { __typename?: 'Community', id: string, name: string }
            | { __typename?: 'Subdivision', id: string, name: string }
            | { __typename?: 'Lot', id: string, name: string }
            | { __typename?: 'Structure', id: string, name: string }
            | { __typename?: 'Unit', id: string, name: string }
          , blueprintUrl: { __typename?: 'Url', path: string } }
        | { __typename?: 'CommitmentChangeOrder', id: string, accountingNumber: number, commitment: { __typename?: 'Commitment', id: string, name: string, project:
              | { __typename?: 'StandaloneProject', id: string, name: string }
              | { __typename?: 'Region', id: string, name: string }
              | { __typename?: 'Market', id: string, name: string }
              | { __typename?: 'Community', id: string, name: string }
              | { __typename?: 'Subdivision', id: string, name: string }
              | { __typename?: 'Lot', id: string, name: string }
              | { __typename?: 'Structure', id: string, name: string }
              | { __typename?: 'Unit', id: string, name: string }
             }, blueprintUrl: { __typename?: 'Url', path: string } }
        | { __typename?: 'Community', id: string, name: string, market: { __typename?: 'Market', id: string, name: string }, blueprintUrl: { __typename?: 'Url', path: string } }
        | { __typename?: 'DesignPackage', displayCode?: string | null | undefined, id: string, name: string, aggregateLatest: { __typename?: 'ReadyPlanAggregateVersion', id: string } }
        | { __typename?: 'Lot', id: string, name: string, market: { __typename?: 'Market', id: string, name: string }, blueprintUrl: { __typename?: 'Url', path: string } }
        | { __typename?: 'Market', id: string, name: string, market: { __typename?: 'Market', id: string, name: string }, blueprintUrl: { __typename?: 'Url', path: string } }
        | { __typename?: 'PlanPackage', displayCode?: string | null | undefined, id: string, name: string, aggregateLatest: { __typename?: 'ReadyPlanAggregateVersion', id: string } }
        | { __typename?: 'ProductOffering', displayCode?: string | null | undefined, id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } }
        | { __typename?: 'Region', id: string, name: string, market?: { __typename?: 'Market', id: string, name: string } | null | undefined, blueprintUrl: { __typename?: 'Url', path: string } }
        | { __typename?: 'StandaloneProject', id: string, name: string, market: { __typename?: 'Market', id: string, name: string }, blueprintUrl: { __typename?: 'Url', path: string } }
        | { __typename?: 'Structure', id: string, name: string, market: { __typename?: 'Market', id: string, name: string }, blueprintUrl: { __typename?: 'Url', path: string } }
        | { __typename?: 'Subdivision', id: string, name: string, market: { __typename?: 'Market', id: string, name: string }, blueprintUrl: { __typename?: 'Url', path: string } }
        | { __typename?: 'TradePartner', id: string, name: string, contacts: Array<{ __typename?: 'TradePartnerContact', id: string, name: string, mobilePhone?: string | null | undefined, officePhone?: string | null | undefined }> }
       } }> };

export type GlobalSearch_RecordFragment = { __typename?: 'GlobalSearchRecord', id: string, parent:
    | { __typename?: 'Bill', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string }, project:
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
       }
    | { __typename?: 'Commitment', id: string, accountingNumber: number, name: string, project:
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      , blueprintUrl: { __typename?: 'Url', path: string } }
    | { __typename?: 'CommitmentChangeOrder', id: string, accountingNumber: number, commitment: { __typename?: 'Commitment', id: string, name: string, project:
          | { __typename?: 'StandaloneProject', id: string, name: string }
          | { __typename?: 'Region', id: string, name: string }
          | { __typename?: 'Market', id: string, name: string }
          | { __typename?: 'Community', id: string, name: string }
          | { __typename?: 'Subdivision', id: string, name: string }
          | { __typename?: 'Lot', id: string, name: string }
          | { __typename?: 'Structure', id: string, name: string }
          | { __typename?: 'Unit', id: string, name: string }
         }, blueprintUrl: { __typename?: 'Url', path: string } }
    | { __typename?: 'Community', id: string, name: string, market: { __typename?: 'Market', id: string, name: string }, blueprintUrl: { __typename?: 'Url', path: string } }
    | { __typename?: 'DesignPackage', displayCode?: string | null | undefined, id: string, name: string, aggregateLatest: { __typename?: 'ReadyPlanAggregateVersion', id: string } }
    | { __typename?: 'Lot', id: string, name: string, market: { __typename?: 'Market', id: string, name: string }, blueprintUrl: { __typename?: 'Url', path: string } }
    | { __typename?: 'Market', id: string, name: string, market: { __typename?: 'Market', id: string, name: string }, blueprintUrl: { __typename?: 'Url', path: string } }
    | { __typename?: 'PlanPackage', displayCode?: string | null | undefined, id: string, name: string, aggregateLatest: { __typename?: 'ReadyPlanAggregateVersion', id: string } }
    | { __typename?: 'ProductOffering', displayCode?: string | null | undefined, id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } }
    | { __typename?: 'Region', id: string, name: string, market?: { __typename?: 'Market', id: string, name: string } | null | undefined, blueprintUrl: { __typename?: 'Url', path: string } }
    | { __typename?: 'StandaloneProject', id: string, name: string, market: { __typename?: 'Market', id: string, name: string }, blueprintUrl: { __typename?: 'Url', path: string } }
    | { __typename?: 'Structure', id: string, name: string, market: { __typename?: 'Market', id: string, name: string }, blueprintUrl: { __typename?: 'Url', path: string } }
    | { __typename?: 'Subdivision', id: string, name: string, market: { __typename?: 'Market', id: string, name: string }, blueprintUrl: { __typename?: 'Url', path: string } }
    | { __typename?: 'TradePartner', id: string, name: string, contacts: Array<{ __typename?: 'TradePartnerContact', id: string, name: string, mobilePhone?: string | null | undefined, officePhone?: string | null | undefined }> }
   };

export type GlobalSearch_Project_StandaloneProject_Fragment = { __typename?: 'StandaloneProject', id: string, name: string, market: { __typename?: 'Market', id: string, name: string }, blueprintUrl: { __typename?: 'Url', path: string } };

export type GlobalSearch_Project_Region_Fragment = { __typename?: 'Region', id: string, name: string, market?: { __typename?: 'Market', id: string, name: string } | null | undefined, blueprintUrl: { __typename?: 'Url', path: string } };

export type GlobalSearch_Project_Market_Fragment = { __typename?: 'Market', id: string, name: string, market: { __typename?: 'Market', id: string, name: string }, blueprintUrl: { __typename?: 'Url', path: string } };

export type GlobalSearch_Project_Community_Fragment = { __typename?: 'Community', id: string, name: string, market: { __typename?: 'Market', id: string, name: string }, blueprintUrl: { __typename?: 'Url', path: string } };

export type GlobalSearch_Project_Subdivision_Fragment = { __typename?: 'Subdivision', id: string, name: string, market: { __typename?: 'Market', id: string, name: string }, blueprintUrl: { __typename?: 'Url', path: string } };

export type GlobalSearch_Project_Lot_Fragment = { __typename?: 'Lot', id: string, name: string, market: { __typename?: 'Market', id: string, name: string }, blueprintUrl: { __typename?: 'Url', path: string } };

export type GlobalSearch_Project_Structure_Fragment = { __typename?: 'Structure', id: string, name: string, market: { __typename?: 'Market', id: string, name: string }, blueprintUrl: { __typename?: 'Url', path: string } };

export type GlobalSearch_Project_Unit_Fragment = { __typename?: 'Unit', id: string, name: string, market: { __typename?: 'Market', id: string, name: string }, blueprintUrl: { __typename?: 'Url', path: string } };

export type GlobalSearch_ProjectFragment =
  | GlobalSearch_Project_StandaloneProject_Fragment
  | GlobalSearch_Project_Region_Fragment
  | GlobalSearch_Project_Market_Fragment
  | GlobalSearch_Project_Community_Fragment
  | GlobalSearch_Project_Subdivision_Fragment
  | GlobalSearch_Project_Lot_Fragment
  | GlobalSearch_Project_Structure_Fragment
  | GlobalSearch_Project_Unit_Fragment
;

export type GlobalSearch_CommitmentFragment = { __typename?: 'Commitment', id: string, accountingNumber: number, name: string, project:
    | { __typename?: 'StandaloneProject', id: string, name: string }
    | { __typename?: 'Region', id: string, name: string }
    | { __typename?: 'Market', id: string, name: string }
    | { __typename?: 'Community', id: string, name: string }
    | { __typename?: 'Subdivision', id: string, name: string }
    | { __typename?: 'Lot', id: string, name: string }
    | { __typename?: 'Structure', id: string, name: string }
    | { __typename?: 'Unit', id: string, name: string }
  , blueprintUrl: { __typename?: 'Url', path: string } };

export type GlobalSearch_CommitmentChangeOrderFragment = { __typename?: 'CommitmentChangeOrder', id: string, accountingNumber: number, commitment: { __typename?: 'Commitment', id: string, name: string, project:
      | { __typename?: 'StandaloneProject', id: string, name: string }
      | { __typename?: 'Region', id: string, name: string }
      | { __typename?: 'Market', id: string, name: string }
      | { __typename?: 'Community', id: string, name: string }
      | { __typename?: 'Subdivision', id: string, name: string }
      | { __typename?: 'Lot', id: string, name: string }
      | { __typename?: 'Structure', id: string, name: string }
      | { __typename?: 'Unit', id: string, name: string }
     }, blueprintUrl: { __typename?: 'Url', path: string } };

export type GlobalSearch_BillFragment = { __typename?: 'Bill', id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string }, project:
    | { __typename?: 'StandaloneProject', id: string, name: string }
    | { __typename?: 'Region', id: string, name: string }
    | { __typename?: 'Market', id: string, name: string }
    | { __typename?: 'Community', id: string, name: string }
    | { __typename?: 'Subdivision', id: string, name: string }
    | { __typename?: 'Lot', id: string, name: string }
    | { __typename?: 'Structure', id: string, name: string }
    | { __typename?: 'Unit', id: string, name: string }
   };

export type GlobalSearch_PlanPackageFragment = { __typename?: 'PlanPackage', displayCode?: string | null | undefined, id: string, name: string, aggregateLatest: { __typename?: 'ReadyPlanAggregateVersion', id: string } };

export type GlobalSearch_DesignPackageFragment = { __typename?: 'DesignPackage', displayCode?: string | null | undefined, id: string, name: string, aggregateLatest: { __typename?: 'ReadyPlanAggregateVersion', id: string } };

export type GlobalSearch_ProductOfferingFragment = { __typename?: 'ProductOffering', displayCode?: string | null | undefined, id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string } };

export type GlobalSearch_TradePartnerFragment = { __typename?: 'TradePartner', id: string, name: string, contacts: Array<{ __typename?: 'TradePartnerContact', id: string, name: string, mobilePhone?: string | null | undefined, officePhone?: string | null | undefined }> };

export const GlobalSearch_BillFragmentDoc = gql`
    fragment GlobalSearch_Bill on Bill {
  id
  name
  blueprintUrl {
    path
  }
  project {
    id
    name
  }
}
    `;
export const GlobalSearch_CommitmentFragmentDoc = gql`
    fragment GlobalSearch_Commitment on Commitment {
  id
  accountingNumber
  name
  project {
    id
    name
  }
  blueprintUrl {
    path
  }
}
    `;
export const GlobalSearch_CommitmentChangeOrderFragmentDoc = gql`
    fragment GlobalSearch_CommitmentChangeOrder on CommitmentChangeOrder {
  id
  accountingNumber
  commitment {
    id
    name
    project {
      id
      name
    }
  }
  blueprintUrl {
    path
  }
}
    `;
export const GlobalSearch_DesignPackageFragmentDoc = gql`
    fragment GlobalSearch_DesignPackage on DesignPackage {
  ...Named
  displayCode
  aggregateLatest {
    id
  }
}
    ${NamedFragmentDoc}`;
export const GlobalSearch_PlanPackageFragmentDoc = gql`
    fragment GlobalSearch_PlanPackage on PlanPackage {
  ...Named
  displayCode
  aggregateLatest {
    id
  }
}
    ${NamedFragmentDoc}`;
export const GlobalSearch_ProductOfferingFragmentDoc = gql`
    fragment GlobalSearch_ProductOffering on ProductOffering {
  ...Named
  displayCode
  blueprintUrl {
    path
  }
}
    ${NamedFragmentDoc}`;
export const GlobalSearch_ProjectFragmentDoc = gql`
    fragment GlobalSearch_Project on Project {
  id
  name
  market {
    id
    name
  }
  blueprintUrl {
    path
  }
}
    `;
export const GlobalSearch_TradePartnerFragmentDoc = gql`
    fragment GlobalSearch_TradePartner on TradePartner {
  id
  name
  contacts {
    id
    name
    mobilePhone
    officePhone
  }
}
    `;
export const GlobalSearch_RecordFragmentDoc = gql`
    fragment GlobalSearch_Record on GlobalSearchRecord {
  id
  parent {
    ...GlobalSearch_Bill
    ...GlobalSearch_Commitment
    ...GlobalSearch_CommitmentChangeOrder
    ...GlobalSearch_DesignPackage
    ...GlobalSearch_PlanPackage
    ...GlobalSearch_ProductOffering
    ...GlobalSearch_Project
    ...GlobalSearch_TradePartner
  }
}
    ${GlobalSearch_BillFragmentDoc}
${GlobalSearch_CommitmentFragmentDoc}
${GlobalSearch_CommitmentChangeOrderFragmentDoc}
${GlobalSearch_DesignPackageFragmentDoc}
${GlobalSearch_PlanPackageFragmentDoc}
${GlobalSearch_ProductOfferingFragmentDoc}
${GlobalSearch_ProjectFragmentDoc}
${GlobalSearch_TradePartnerFragmentDoc}`;
export const GlobalSearchModalDocument = gql`
    query GlobalSearchModal($search: String!) {
  globalSearch(query: $search) {
    record {
      ...GlobalSearch_Record
    }
  }
}
    ${GlobalSearch_RecordFragmentDoc}`;

/**
 * __useGlobalSearchModalQuery__
 *
 * To run a query within a React component, call `useGlobalSearchModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalSearchModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalSearchModalQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGlobalSearchModalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GlobalSearchModalQuery, GlobalSearchModalQueryVariables> & ({ variables: GlobalSearchModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GlobalSearchModalQuery, GlobalSearchModalQueryVariables>(GlobalSearchModalDocument, options);
      }
export function useGlobalSearchModalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GlobalSearchModalQuery, GlobalSearchModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GlobalSearchModalQuery, GlobalSearchModalQueryVariables>(GlobalSearchModalDocument, options);
        }
// @ts-ignore
export function useGlobalSearchModalSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GlobalSearchModalQuery, GlobalSearchModalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GlobalSearchModalQuery, GlobalSearchModalQueryVariables>;
export function useGlobalSearchModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GlobalSearchModalQuery, GlobalSearchModalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GlobalSearchModalQuery | undefined, GlobalSearchModalQueryVariables>;
export function useGlobalSearchModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GlobalSearchModalQuery, GlobalSearchModalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GlobalSearchModalQuery, GlobalSearchModalQueryVariables>(GlobalSearchModalDocument, options);
        }
export type GlobalSearchModalQueryHookResult = ReturnType<typeof useGlobalSearchModalQuery>;
export type GlobalSearchModalLazyQueryHookResult = ReturnType<typeof useGlobalSearchModalLazyQuery>;
export type GlobalSearchModalSuspenseQueryHookResult = ReturnType<typeof useGlobalSearchModalSuspenseQuery>;
export type GlobalSearchModalQueryResult = Apollo.QueryResult<GlobalSearchModalQuery, GlobalSearchModalQueryVariables>;